import React, { useEffect, useState } from "react";
import "./terms.css";
import axios from "axios";

const AboutUs = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAboutUs = async () => {
      try {
        const res = await axios.get(
          "https://fom.softsprint.ae/backendTest/info/about-us",
        );
        setData(res.data.data);
      } catch (err) {
        setError("Failed to load about us");
      } finally {
        setLoading(false);
      }
    };

    fetchAboutUs();
  }, []);

  if (loading) return <div className="terms-status">Loading...</div>;
  if (error) return <div className="terms-status error">{error}</div>;

  return (
    <div className="about-container">
      <div className="about-card">
        <h1 className="about-title">{data.platform_name}</h1>
        <p className="about-tagline">{data.tagline}</p>

        <p className="about-description">{data.description}</p>

        <div className="about-section">
          <h2>Mission</h2>
          <p>{data.mission}</p>
        </div>

        <div className="about-section">
          <h2>Vision</h2>
          <p>{data.vision}</p>
        </div>

        <div className="about-section">
          <h2>Key Features</h2>
          <div className="features-grid">
            {data.features.map((feature, index) => (
              <div key={index} className="feature-card">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="about-section">
          <h2>Contact</h2>
          <p>Email: {data.contact.email}</p>
          <p>Phone: {data.contact.phone}</p>
          <p>
            Website:{" "}
            <a href={data.contact.website} target="_blank" rel="noreferrer">
              {data.contact.website}
            </a>
          </p>
        </div>

        <div className="about-footer">
          <span>Version: {data.version}</span>
          <span>Last Updated: {data.last_updated}</span>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
